import UploadPage from "../components/UploadPage"

const Upload = () => {


    return (
        <div>
            <h2>Upload Page</h2>
            <UploadPage />
        </div>
    )
}

export default Upload